import { FunctionComponent } from "react";
import { IconProps } from "./constants";

const Search: FunctionComponent<IconProps> = ({ width = 14, height = 15, color = "#122A26", ...props }: IconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 22 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-name={props.name || "search"}
      data-testid={props.name || "search"}
    >
      <path
        d="M20 19L15.65 14.8917M18.0001 9.55552C18.0001 13.7283 14.4183 17.111 10 17.111C5.58174 17.111 2 13.7283 2 9.55552C2 5.38272 5.58174 2 10 2C14.4183 2 18.0001 5.38272 18.0001 9.55552Z"
        stroke={color}
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20 19L15.65 14.8917M18.0001 9.55552C18.0001 13.7283 14.4183 17.111 10 17.111C5.58174 17.111 2 13.7283 2 9.55552C2 5.38272 5.58174 2 10 2C14.4183 2 18.0001 5.38272 18.0001 9.55552Z"
        stroke="black"
        strokeOpacity="0.2"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Search;
